import { environment } from 'src/environments/environment';

export class Constants {

  public navLinkItems = {
    home: { home: { displayName: 'Home', url: 'home' } },
		user: {
			person: { displayName: 'MAX JONES', icon: 'person' },
			id: { displayName: '10034' },
			profile: { displayName: 'ADMIN' },
			help: { displayName: 'HELP', icon: 'help' },
			settings: { displayName: 'SETTINGS', icon: 'settings' },
			logout: { displayName: 'LOGOUT', icon: 'logout' }
		},
		planning: {
			alarms: { displayName: 'ALARMS', url: environment.ALARMS },
			allo: { displayName: 'ALLO', url: environment.ALLO },
			companyInfoChange: { displayName: 'company Info Change', url: 'mshell/maintenance/company-info-change' },
			costPlanning: { displayName: 'COST PLANNING', url: environment.COST_PLANNING },
			eboi: { displayName: 'EBOI', url: environment.EBOI },
			exports: { displayName: 'EXPORTS', url: environment.EXPORT },
			forecastAdmin: { displayName: 'Forecast Admin Dashboard (Import/Export dashboard)', url: environment.FORECAST_ADMIN_DASHBOARD },
			fto: { displayName: 'FTOs', url: 'opershell/operations/fto' },
			group1: { displayName: 'GROUP I', url: environment.GROUPI },
			dashboard: { displayName: 'Import/Export', url: 'opershell/operations/dashboard' },
			masterDock: { displayName: 'Master Dock', url: 'mshell/maintenance/master-dock' },
			regionTargets: { displayName: 'Region Targets', url: 'opershell/operations/region-targets' },
			scnc: { displayName: 'SCNC', url: 'opershell/operations/scnc' },
			taskManager: { displayName: 'TASK MANAGER', url: environment.TASK_MANAGER },
			tlmsSend: { displayName: 'TLMS Send', url: environment.TLMS_SEND },
			delayedDispatch: { displayName: 'Delayed Dispatch', url: environment.DD },
		},
		operations: {
			aet: { displayName: 'AET', url: environment.AET },
			companyInfo: { displayName: 'company Info', url: 'mshell/maintenance/company-info' },
			lpBilling: { displayName: 'LP Billing', url: 'bshell', fga: ['Billing Master', 'Logistics Cost Management', 'Cost Master', 'DRC', 'General Costs', 'Expedite Costs', 'Surcharges', 'LP Invoice', 'Billing Summary'] },
			trailerLoadDiagrams: { displayName: 'Trailer Load Diagrams', url: environment.TLD },
			uxmxroutes: { displayName: 'US MX Routes', url: 'opershell/operations/uxmxroutes' },
			wtResolution: { displayName: 'WT Resolution ', url: 'mshell/maintenance/window-times', fga: ['Window Times', 'TLMS Send'] },
			returnsReload: { displayName: 'Returns Reload', url: 'mshell/maintenance/returns-reload' },
		},
		reporting: {
			scheduleDashboard: { displayName: 'Schedule Dashboard', url: environment.SCHEDULE_DASHBOARD },
			reports: { displayName: 'Reports', url: environment.REPORTS },
		},
		maintenance: {
			notificationGroup: { displayName: 'Notification Group', url: 'admin/notification-group' },
			permissionManagement: { displayName: 'Permission Management', url: 'mshell/apm/permission-management/user-management' },
		}
  };
  
  public liosMenuItems = [
		{ displayName: 'COMPANY INFORMATION' },
		{ displayName: 'MASTER DATA' },
		{ displayName: 'IMPORT/EXPORT' },
		{ displayName: 'WINDOW TIMES' },
		{ displayName: 'REPORTING' },
		{ displayName: 'ADMIN' },
		{ displayName: 'BILLING' },
		{ displayName: 'DELAYED DISPATCH' },
		{ displayName: 'AET' },
		{ displayName: 'TSCS' },
		{ displayName: 'TPT' },
		{ displayName: 'PLANNING' },
		{ displayName: 'EXPORTS PARTS' }
	];

  public timeZones = {
    EST: 'UTC-5',
    EDT: 'UTC-4',
    CST: 'UTC-6',
    CDT: 'UTC-5',
    MST: 'UTC-7',
    MDT: 'UTC-6',
    PST: 'UTC-8',
    PDT: 'UTC-7',
  };
  public eventStatuses = [
    {
      description: 'Arrived',
      id: 'A',
    },
    {
      description: 'Broken Route',
      id: 'B',
    },
    {
      description: 'Closed',
      id: 'X',
    },
    {
      description: 'Confirmed',
      id: 'F',
    },
    {
      description: 'In Progress',
      id: 'O',
    },
    {
      description: 'Partial Route',
      id: 'P',
    },
  ];
  public logisticalPartners = [
    {
      defaultFlag: true,
      sAPCompanyCode: '2058021263',
      shortName: 'Transfreight',
      vendorCode: 'TRF',
      vendorId: 1,
      vendorName: 'Transfreight',
      vendorNumber: '0000103408',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058008508',
      shortName: 'Carter',
      vendorCode: 'CRT',
      vendorId: 2,
      vendorName: 'Carter',
      vendorNumber: '0000118660',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058005337',
      shortName: 'Ascent',
      vendorCode: 'AEA',
      vendorId: 3,
      vendorName: 'Ascent',
      vendorNumber: '0000111283',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: null,
      shortName: 'Challenger',
      vendorCode: 'CLG',
      vendorId: 4,
      vendorName: 'Challenger',
      vendorNumber: '002',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2050000228',
      shortName: 'Hero Logistics',
      vendorCode: 'HRL',
      vendorId: 5,
      vendorName: 'Hero Logistics',
      vendorNumber: '0000114537',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058016901',
      shortName: 'KC Transport',
      vendorCode: 'KCT',
      vendorId: 6,
      vendorName: 'KC Transport',
      vendorNumber: '0000000144',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: null,
      shortName: 'NYK Logistics',
      vendorCode: 'NYK',
      vendorId: 7,
      vendorName: 'NYK Logistics',
      vendorNumber: '0000108892',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: null,
      shortName: 'Online',
      vendorCode: 'OLT',
      vendorId: 8,
      vendorName: 'Online',
      vendorNumber: '007',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: null,
      shortName: 'OWL',
      vendorCode: 'OWL',
      vendorId: 9,
      vendorName: 'OWL',
      vendorNumber: '008',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058023512',
      shortName: 'Rush',
      vendorCode: 'RSH',
      vendorId: 12,
      vendorName: 'Rush',
      vendorNumber: '0000106739',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058023524',
      shortName: 'Russell',
      vendorCode: 'RSL',
      vendorId: 13,
      vendorName: 'Russell',
      vendorNumber: '0000112883',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058003569',
      shortName: 'Tsusho',
      vendorCode: 'TAI',
      vendorId: 14,
      vendorName: 'Tsusho',
      vendorNumber: '0000103790',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: null,
      shortName: 'West Tenn. Exp',
      vendorCode: 'WTE',
      vendorId: 15,
      vendorName: 'West Tenn. Exp',
      vendorNumber: '016',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058001478',
      shortName: 'Vascor',
      vendorCode: 'VSC',
      vendorId: 16,
      vendorName: 'Vascor',
      vendorNumber: '0000102946',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058028991',
      shortName: 'XPO Logistics',
      vendorCode: 'XPO',
      vendorId: 42,
      vendorName: 'XPO Logistics',
      vendorNumber: '2058028991',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058001899',
      shortName: 'Ryder',
      vendorCode: 'RYD',
      vendorId: 21,
      vendorName: 'Ryder',
      vendorNumber: '0000103219',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058018400',
      shortName: 'Magnolia',
      vendorCode: 'MAG',
      vendorId: 81,
      vendorName: 'Magnolia',
      vendorNumber: '0000125247',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058008796',
      shortName: 'C.H. Robinson',
      vendorCode: 'CHR',
      vendorId: 18,
      vendorName: 'C.H. Robinson',
      vendorNumber: '2058008796',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058021623',
      shortName: 'Penske',
      vendorCode: 'PEN',
      vendorId: 141,
      vendorName: 'Penske',
      vendorNumber: '0000103408',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '001',
      shortName: 'Black Horse',
      vendorCode: 'BHC',
      vendorId: 221,
      vendorName: 'Black Horse Carriers',
      vendorNumber: '2058003057',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2058028091',
      shortName: 'WW Rowland',
      vendorCode: 'WWR',
      vendorId: 301,
      vendorName: 'WW Rowland',
      vendorNumber: '2058028091',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2050000680',
      shortName: 'Aralo',
      vendorCode: 'ARA',
      vendorId: 261,
      vendorName: 'Transportes Aralo',
      vendorNumber: '2050000680',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2050000249',
      shortName: 'Fletes',
      vendorCode: 'FLM',
      vendorId: 241,
      vendorName: 'Fletes Mexico',
      vendorNumber: '2050000249',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2050000266',
      shortName: 'Autolineas',
      vendorCode: 'ALA',
      vendorId: 281,
      vendorName: 'Autolineas America',
      vendorNumber: '2050000266',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '2050004798',
      shortName: 'Spartan',
      vendorCode: 'SCG',
      vendorId: 321,
      vendorName: 'Spartan Carrier Group',
      vendorNumber: '2050004798',
    },
    {
      defaultFlag: true,
      sAPCompanyCode: '002',
      shortName: 'SCD',
      vendorCode: 'SCD',
      vendorId: 382,
      vendorName: 'Scd',
      vendorNumber: '001',
    },
  ];

  public eventPrbType = [
    {
      eventTypeId: 1,
      eventType: 'Blowout',
      problemTypes: [
        {
          problemTypeId: 10,
          description: 'Over Weight',
        },
        {
          problemTypeId: 30,
          description: 'Cubeout',
        },
      ],
    },
    {
      eventTypeId: 2,
      eventType: 'Late Route',
      problemTypes: [
        {
          problemTypeId: 1,
          description: 'No Driver - HOS',
        },
        {
          problemTypeId: 2,
          description: 'No Driver - Call In',
        },
        {
          problemTypeId: 4,
          description: 'Supplier Delay',
        },
        {
          problemTypeId: 5,
          description: 'Road Closure/Disruption',
        },
        {
          problemTypeId: 6,
          description: 'Equipment Unavailable',
        },
        {
          problemTypeId: 7,
          description: 'Equipment Breakdown',
        },
        {
          problemTypeId: 8,
          description: 'New Event',
        },
        {
          problemTypeId: 9,
          description: 'Border Delay',
        },
        {
          problemTypeId: 12,
          description: 'Port Delay',
        },
        {
          problemTypeId: 21,
          description: 'Dispatch late',
        },
        {
          problemTypeId: 22,
          description: 'Yard arrival late',
        },
        {
          problemTypeId: 23,
          description: 'Held at supplier dock',
        },
        {
          problemTypeId: 24,
          description: 'Missed supplier window time',
        },
        {
          problemTypeId: 25,
          description: 'Traffic Delay',
        },
        {
          problemTypeId: 26,
          description: 'Weather Delay',
        },
        {
          problemTypeId: 27,
          description: 'Dropped Route',
        },
        {
          problemTypeId: 28,
          description: 'Dock-locked at supplier',
        },
        {
          problemTypeId: 44,
          description: 'Drive Delay',
        },
        {
          problemTypeId: 46,
          description: 'Accident in route',
        },
      ],
    },
    {
      eventTypeId: 10,
      eventType: 'Missconnect',
      problemTypes: [
        {
          problemTypeId: 31,
          description: 'Shortage at SR Unload',
        },
        {
          problemTypeId: 32,
          description: 'Missed SR Unload',
        },
        {
          problemTypeId: 33,
          description: 'Will not make MR Reload',
        },
      ],
    },
    {
      eventTypeId: 11,
      eventType: 'Missed Unload',
      problemTypes: [
        {
          problemTypeId: 34,
          description: 'Will not make Shuttle Unload',
        },
        {
          problemTypeId: 35,
          description: 'Will not make NAMC Unload',
        },
      ],
    },
    {
      eventTypeId: 9,
      eventType: 'Out of Plan',
      problemTypes: [
        {
          problemTypeId: 19,
          description: 'Urgent Supplement',
        },
        {
          problemTypeId: 20,
          description: 'Non-Urgent Supplement',
        },
        {
          problemTypeId: 40,
          description: 'Freight shipped on wrong route',
        },
        {
          problemTypeId: 41,
          description: 'Returns recovery',
        },
        {
          problemTypeId: 42,
          description: 'Freight shipped ahead',
        },
        {
          problemTypeId: 43,
          description: 'Late arrival freight',
        },
      ],
    },
    {
      eventTypeId: 4,
      eventType: 'Preemptive',
      problemTypes: [
        {
          problemTypeId: 14,
          description: 'NAMC Request',
        },
        {
          problemTypeId: 15,
          description: 'Weather',
        },
        {
          problemTypeId: 29,
          description: 'TEMA Request',
        },
      ],
    },
    {
      eventTypeId: 12,
      eventType: 'Returns Recovery',
      problemTypes: [
        {
          problemTypeId: 36,
          description: 'Due to blowout',
        },
        {
          problemTypeId: 37,
          description: 'Period changeover',
        },
        {
          problemTypeId: 45,
          description: 'Off route returns',
        },
      ],
    },
    {
      eventTypeId: 3,
      eventType: 'Shortage',
      problemTypes: [
        {
          problemTypeId: 3,
          description: 'Supplier Closed/Disruption',
        },
        {
          problemTypeId: 13,
          description: 'Not found at subroute unload',
        },
        {
          problemTypeId: 16,
          description: 'Supplier Shortage',
        },
        {
          problemTypeId: 38,
          description: 'Not found at mainroute reload',
        },
        {
          problemTypeId: 39,
          description: 'Freight already picked up',
        },
      ],
    },
  ];

  
  public LIOSMainPortalURL = '';
  public LIOS_UAC_Admin = 'Admin';
  public LIOS_UAC_TEMA_Ops = 'TEMA Ops';
  public LIOS_UAC_LP_Filter = 'Logistics Partner';
  public LIOS_UAC_TaskManagerAdmin = 'Task Manager Admin';
  public LIOS_UAC_TaskManagerUser = 'Task Manager User';
  public LIOS_UAC_NAMC_Planner = 'NAMC Planner';
  public LIOS_UAC_MTM_Planner = 'MTM Planner';
  public LIOS_UAC_AET_LP = 'AET LP';
  public LIOS_UAC_AET_Admin = 'AET Admin';
  public LIOS_UAC_General_User = 'General User';
  public LIOS_UAC_Forecast_Admin = 'Forecast Admin';
  public LIOS_UAC_LPD_Admin = 'LPD Admin';
  public LIOS_UAC_Reporting_Admin = 'Reporting Admin';
  public LIOS_UAC_Reporting_User = 'Reporting User';
  public LIOS_UAC_Route_Planner = 'Route Planner';
  public LIOS_UAC_TEMA_LBM_LC_Planner = 'TEMA LBM LC PLANNER';
  public LIOS_UAC_TEMA_OPS_Specialist = 'TEMA OPS - Specialist';
  public LIOS_UAC_WT_Administrator = 'WT Administrator';
  public LIOS_UAC_MTMUS_Planner = 'MTMUS Planner';
  public LIOS_UAC_Portal_Administrator = 'Portal Administrator';
  public LIOS_UAC_Security_Admin = 'Security Admin';
  public LIOS_UAC_TEMA_AF = 'TEMA AF';
  public LIOS_UAC_TEMA_Budgeting = 'TEMA Budgeting';
  public LIOS_UAC_TEMA_OPS_AM = 'TEMA OPS - AM';
  public LIOS_UAC_TEMA_Purchasing = 'TEMA Purchasing';
  public LIOS_UAC_TEMA_LC = 'TEMA-LC';
  public LIOS_UAC_TPT_Admin = 'TPT Admin';
  public LIOS_UAC_TSCS_Admin = 'TSCS Admin';
  public LIOS_UAC_MTMUS_Negotiator = 'MTMUS Negotiator';
  public LIOS_UAC_NAMC_Contacts = 'NAMC Contacts';
  public LIOS_UAC_LP_Admin = 'LP Admin';
  public LIOS_UAC_LPV_Admin = 'LPV Admin';
  public LIOS_UAC_LCM_Super_Admin = 'LCM Super Admin';
  public LIOS_UAC_Billing_Administrator = 'Billing Administrator';
  public LIOS_UAC_Communication_Admin = 'Communication Admin';
  public LIOS_UAC_Cross_Dock = 'Cross Dock';
  public LIOS_UAC_Cross_Dock_PL = 'CrossDock PL';
  public LIOS_UAC_Domicile_Filter = 'Domicile Filter';
  public LIOS_UAC_Inactive = 'Inactive';
  public LIOS_UAC_SCV_Admin = 'SCV Admin';
  public notificationMessageTimeShort = 6000;
  public LoaderComponent = 'loader-component';
  public LoaderInitializer = 'loader-initializer';
  public FileValidation = 'Validation failed, Please find error details below';
  public APIErrorMessage = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists.';
  public APIDataSaved = 'Data saved successfully';
  public APIDataUpdated = 'Data updated successfully';
  public APIDataDeleted = 'Data deleted successfully';
  public notificationMessageTime = 6000;

  public downloadError = 'Error downloading the file';
	public LIOS_UAC_NAMCPlanner60EXP = "NAMC Planner/60EXP";
	public FileUploaded = "File uploaded successfully";
	public failedFileUpload ="File Upload Failed!"

  constructor() {
    this.LIOSMainPortalURL = environment.LIOS_HOME_URL;
  }
}

export const generateRandomString = (length = 6): string => {
		const chars =
			'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let result = '';
		for (let i = 0; i < length; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return result;
	};

export const	FILE_UPLOAD_TIMEOUT = 300000;
